import React from 'react'
import useSearch from '../../../context/search/useSearch'

interface ISearchResultsCollectionsComponent {
  dataSet: DOMStringMap
}

const SearchResultsCollections: React.FC<ISearchResultsCollectionsComponent> = ({dataSet}): JSX.Element => {

  const {langTitle} = dataSet

  const {quickSearchResultsPages} = useSearch()

  if (quickSearchResultsPages && !quickSearchResultsPages.length) return null

  return (
    <React.Fragment>
      <div className={'sf-results sf-results-collections'}>
        {(quickSearchResultsPages && quickSearchResultsPages.length) && <React.Fragment>
         
          <div className={'sf-results-collections-items sf-results-loaded'}>
            {quickSearchResultsPages && <div className={'sf-results-collections-title sf-results-title'}>{langTitle}</div>}
            {quickSearchResultsPages.map((page, index) => {
              return (
                <li className={'sf-results-collections-item'} key={index}>
                  <a href={page.url}>{ page.title }</a>
                </li>
              )
            })}
          </div>
        </React.Fragment>}
      </div>
    </React.Fragment>
  )
}

export default SearchResultsCollections